import React from 'react';
import CommentBox from './CommentBox';
import CommentList from './CommentList';
import useComments from './useComments';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-solid-svg-icons';

function AnswerQuestion({ postId, fromColorBg, toColorBg }) {
    const { isLogined, userInfo } = useSelector((state) => state.auth);
    const {
        comments,
        hasMoreComments,
        newComment,
        setNewComment,
        newReply,
        setReply,
        highlightId,
        highlightReplyId,
        pendingNotice,
        onOpenReply,
        onPostComment,
        onNewReply,
        onDeleteComment,
        onDeleteReply,
        onLoadComment,
    } = useComments(postId);

    return (
        <div className="p-3 sm:p-4 bg-surface rounded-2xl">
            <div className="flex items-center gap-2 mb-3">
                <div
                    className={`h-8 w-8 min-w-[32px] rounded-full bg-gradient-to-br flex justify-center items-center ${
                        fromColorBg || 'from-primary-500'
                    } ${toColorBg || 'to-primary-600'}`}
                >
                    <FontAwesomeIcon icon={faComments} className="text-white text-sm" />
                </div>
                <h3 className="font-bold text-content">
                    Bình luận ({comments.length})
                </h3>
            </div>

            {pendingNotice && (
                <div className="mb-3">
                    <span className="inline-block bg-amber-50 text-amber-700 rounded-full px-3 py-1 text-xs">
                        Bình luận của bạn sẽ hiển thị sau khi được quản trị viên duyệt.
                    </span>
                </div>
            )}

            {!isLogined && (
                <div className="flex justify-center py-3">
                    <Link
                        to={'/login'}
                        className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-full transition-colors"
                    >
                        Đăng nhập để bình luận
                    </Link>
                </div>
            )}

            {isLogined && (
                <div className="mb-3">
                    <CommentBox
                        value={newComment}
                        setValue={setNewComment}
                        onSubmit={onPostComment}
                        autoFocus={false}
                        avatar={userInfo?.avatar}
                    />
                </div>
            )}

            <CommentList
                comments={comments}
                isLogined={isLogined}
                userInfo={userInfo}
                highlightId={highlightId}
                highlightReplyId={highlightReplyId}
                onOpenReply={onOpenReply}
                onDeleteComment={onDeleteComment}
                onDeleteReply={onDeleteReply}
                newReply={newReply}
                setReply={setReply}
                onNewReply={onNewReply}
            />

            {/* Hết bình luận (server trả ít hơn limit) → ẩn nút tải thêm */}
            {hasMoreComments && (
                <div className="pt-3 flex justify-center">
                    <button
                        type="button"
                        onClick={onLoadComment}
                        className="px-4 py-2 border border-line rounded-full text-sm text-content-2 hover:border-primary-400 hover:text-primary-500 transition-colors"
                    >
                        Tải thêm bình luận
                    </button>
                </div>
            )}
        </div>
    );
}

export default AnswerQuestion;